// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"xma-z"};